import React, { Fragment, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getMyActivities } from '../../actions/activity';
import { makeStyles } from '@material-ui/core';
import Activity from '../SideBars/Activity';

const AllActivites = ({ getMyActivities, activity: { activities } }) => {
  const useStyles = makeStyles(theme => ({
    root: { display: 'flex', marginTop: '1em' },
    body: {
      margin: '0 0 1em 0',
      background: '#F2F4F4',
      color: '#333',
      height: '150px',
      width: '900px'
    },
    head: {
      background: '#D5D8DC',
      padding: '5px'
    },
    footer: { padding: '5px', color: '#333' }
  }));

  const classes = useStyles();

  useEffect(() => {
    getMyActivities();
  }, [getMyActivities]);
  return (
    <div className={classes.root}>
      <div>
        <Activity />
      </div>
      <div>
        <Fragment>
          {activities && activities.length > 0 && (
            <Fragment>
              <div>
                {activities.map(activity => (
                  <div className={classes.body}>
                    <h3 className={classes.head}>{activity.type}</h3>
                    <ul>
                      <li>
                        <Link
                          to={`/show_contact/${activity.contact}`}
                          className={classes.footer}
                        >
                          {activity.name}
                        </Link>
                      </li>
                    </ul>
                  </div>
                ))}
              </div>
            </Fragment>
          )}
        </Fragment>
      </div>
    </div>
  );
};

AllActivites.propTypes = {
  getMyActivities: PropTypes.func.isRequired,
  activity: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  activity: state.activity
});

export default connect(mapStateToProps, { getMyActivities })(AllActivites);



// WEBPACK FOOTER //
// ./src/components/activity/AllActivities.js